import axios from "axios"
import { baseUrlPostGres } from "../constant"
import HandleError from "../HandleError"
import { apiHeader } from "./ApiHeader"
import { IS_LOADING, STATE_LIST_SUCCESS, STATE_LIST_ERROR, STATE_UPDATE_SUCCESS, STATE_UPDATE_ERROR } from "./Type"
import { apiVersion } from "src/utils/apiVersion"

export const GetStateListAction = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/statemanger/list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: STATE_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: STATE_LIST_ERROR,
                payload: errors
            })
            console.log("user list error", errors);
        })
}

export const UpdateStateStatusAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/statemanger/edit`, data)
        .then((response) => {
            dispatch({
                type: STATE_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: STATE_UPDATE_ERROR,
                payload: errors
            })
            console.log("user list error", errors);
        })
}

export const ResetUpdateStateStatusAction = () => async (dispatch) => {
    dispatch({
        type: STATE_UPDATE_SUCCESS,
        payload: {}
    })
}